var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo",on:{"click":_vm.onHome}},[_c('img',{staticClass:"logo-image",attrs:{"src":"/logo.png","alt":""}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"logo-title"},[_vm._v("智云"),_c('span',{staticStyle:{"font-size":"12px","margin-left":"2px","font-style":"italic"}},[_vm._v("一站式DevOps平台")])])
}]

export { render, staticRenderFns }